





































import {Component, Prop, Vue} from 'vue-property-decorator';

export enum ActionMenuDirection {
  Top,
  Right,
  Bottom,
  Left,
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
}

export enum ActionMenuType {
  Header,
  Button,
}

export interface ActionMenuItem {
  label: string;
  type?: ActionMenuType;
  icon?: string;
  action?: () => void;
  disabled?: boolean;
}

@Component({})
export default class Popover extends Vue {
  @Prop(Array) protected items!: ActionMenuItem[];
  @Prop(String) protected buttonClasses!: string;
  @Prop({type: Number, default: ActionMenuDirection.Bottom}) protected direction!: ActionMenuDirection;
  @Prop({type: Boolean, default: false}) protected disabled!: boolean;

  private open: boolean = false;
  private top: number | null = null;
  private bottom: number | null = null;
  private left: number | null = null;
  private right: number | null = null;

  private get classes() {
    return {
      'menu-top': this.direction === ActionMenuDirection.Top,
      'menu-right': this.direction === ActionMenuDirection.Right,
      'menu-bottom': this.direction === ActionMenuDirection.Bottom,
      'menu-left': this.direction === ActionMenuDirection.Left,
      'menu-top-left': this.direction === ActionMenuDirection.TopLeft,
      'menu-top-right': this.direction === ActionMenuDirection.TopRight,
      'menu-bottom-left': this.direction === ActionMenuDirection.BottomLeft,
      'menu-bottom-right': this.direction === ActionMenuDirection.BottomRight,
    };
  }

  public close() {
    this.open = false;
  }

  get menuStyle() {
    const style: any = {};

    if (this.top !== null) {
      style.top = this.top + 'px';
    }
    if (this.bottom !== null) {
      style.bottom = this.bottom + 'px';
    }
    if (this.left !== null) {
      style.left = this.left + 'px';
    }
    if (this.right !== null) {
      style.right = this.right + 'px';
    }

    return style;
  }

  private position(event: Event) {
    const padding = 6;
    const target = (this.$refs.actionToggle as HTMLElement);
    const buttonTop = target.offsetTop;
    const buttonLeft = target.offsetLeft;
    const buttonWidth = target.offsetWidth;
    const buttonHeight = target.offsetHeight;
    const menuWidth = (this.$refs.actionMenu as HTMLElement).offsetWidth;
    const menuHeight = (this.$refs.actionMenu as HTMLElement).offsetHeight;

    this.top = null;
    this.bottom = null;
    this.left = null;
    this.right = null;

    switch (this.direction) {
      case ActionMenuDirection.Top:
        this.top = buttonTop - menuHeight - padding;
        this.left = buttonLeft + (buttonWidth / 2) - (menuWidth / 2);
        break;

      case ActionMenuDirection.Right:
        this.top = buttonTop + (buttonHeight / 2) - (menuHeight / 2);
        this.left = buttonLeft + buttonWidth + padding;
        break;

      case ActionMenuDirection.Bottom:
        this.top = buttonTop + buttonHeight + padding;
        this.left = buttonLeft + (buttonWidth / 2) - (menuWidth / 2);
        break;

      case ActionMenuDirection.Left:
        this.top = buttonTop + (buttonHeight / 2) - (menuHeight / 2);
        this.left = buttonLeft - menuWidth - padding;
        break;

      case ActionMenuDirection.TopLeft:
        this.top = buttonTop - menuHeight - padding;
        this.left = padding;
        break;

      case ActionMenuDirection.TopRight:
        this.top = buttonTop - menuHeight - padding;
        this.right = padding;
        break;

      case ActionMenuDirection.BottomLeft:
        this.top = buttonTop + buttonHeight + padding;
        this.left = padding;
        break;

      case ActionMenuDirection.BottomRight:
        this.top = buttonTop + buttonHeight + padding;
        this.right = padding;
        break;
    }
  }

  private toggle(event: Event) {
    this.open = !this.open;
    this.$nextTick(() => {
      if (this.open) {
        this.position(event);
      }
    });
  }

  private click(action: () => void) {
    this.close();

    if (action) {
      action();
    }
  }
}
